import { render, staticRenderFns } from "./editChegua.vue?vue&type=template&id=3965f612&scoped=true&"
import script from "./editChegua.vue?vue&type=script&lang=js&"
export * from "./editChegua.vue?vue&type=script&lang=js&"
import style0 from "./editChegua.vue?vue&type=style&index=0&id=3965f612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965f612",
  null
  
)

export default component.exports